/**
 * Bump these when Terms / Privacy / Cookie policy materially change.
 * Drives re-consent prompts and audit log version fields.
 */
export const CURRENT_TERMS_VERSION = '2025-03-16';
export const CURRENT_PRIVACY_VERSION = '2025-03-16';
export const CURRENT_COOKIE_POLICY_VERSION = '2025-03-16';

export const LEGAL_CONTACT = {
  termsEmail: 'legal@coremonit.com',
  privacyEmail: 'privacy@coremonit.com',
};
